import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { CALCULATOR_TYPE } from '../types';
import { DEFAULT_BACKEND_HOST, DEFAULT_HEADERS } from './constants';
var kebabRegex = /[A-Z]+(?![a-z])|[A-Z]/g;
function convertToKebab(value) {
  return value.replaceAll(kebabRegex, function ($, ofs) {
    return (ofs ? '-' : '') + $.toLowerCase();
  });
}
function prepareProductType(productName) {
  if (!productName) throw new Error("no productName");
  switch (productName) {
    case 'cloudContainerKubernetes':
      return 'cloud-container-engine';
    case 'ruGpt_3':
      return 'rugpт-3';
    // мб rugpt-3?
    case 'ruDallЕ':
      return 'rudall-е';
    default:
      return convertToKebab(productName);
  }
}
var CALCULATOR_PRICES_URL = '/calculator/v2/prices/';
/**
 *
 * Функция для отправки запросов на цены
 * @function helper
 */
export function getFetcherFn() {
  var backendHost = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_BACKEND_HOST;
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return /*#__PURE__*/function () {
    var _fetcherFn = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
      var formData, productId, calculatorType, productTypeKebab, url, res, response;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            formData = _ref.formData, productId = _ref.productId, calculatorType = _ref.calculatorType;
            if (formData) {
              _context.next = 3;
              break;
            }
            return _context.abrupt("return", undefined);
          case 3:
            productTypeKebab = prepareProductType(productId);
            url = backendHost + CALCULATOR_PRICES_URL + productTypeKebab;
            if (calculatorType === CALCULATOR_TYPE.Partners) url = url + '?calculator_type=partners';
            _context.next = 8;
            return fetch(url, {
              method: 'POST',
              headers: _objectSpread(_objectSpread({}, DEFAULT_HEADERS), params.headers),
              body: formData
            });
          case 8:
            res = _context.sent;
            if (res.ok) {
              _context.next = 11;
              break;
            }
            throw new Error("fetcher");
          case 11:
            _context.next = 13;
            return res.json();
          case 13:
            response = _context.sent;
            if (response.success) {
              _context.next = 16;
              break;
            }
            throw new Error("fetcher - success false");
          case 16:
            return _context.abrupt("return", response.data);
          case 17:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    function fetcherFn(_x) {
      return _fetcherFn.apply(this, arguments);
    }
    return fetcherFn;
  }();
}